import { mutatorAction } from 'satcheljs';
import ClassificationViewState from '../store/schema/ClassificationViewState';
import MessageClassificationType from 'owa-service/lib/contract/MessageClassificationType';

export default mutatorAction(
    'setMessageClassification',
    (viewState: ClassificationViewState, classificationToSet: MessageClassificationType) => {
        viewState.messageClassification = classificationToSet;
    }
);
